<template>
    <div class="documents">
        <h1 class="title title--line"><T>Benodigde documenten</T></h1>
        <p><T>Gelieve ons volgende documenten te bezorgen:</T></p>
        <message v-for="(message, key) in messages"
                :message="message.message"
                :status="message.status" :key="key">

        </message>
        <ul class="document__list">
            <li class="document__item"
                v-for="(item, id) in documents"
                v-bind:class="{'document__item--no-hover' : item.isDeclinedFlag || (item.status &&  documentIdsExpired.includes(item.id)) }">
                <!--status open-->
                <router-link v-if="! item.status && ! item.isDeclinedFlag && item.copyRequired"
                             class="document__name"
                             :to="{ name: 'document-upload', params: { document: item.slug }}">
                    {{item.title}}
                </router-link>
                <router-link v-if="! item.status && ! item.isDeclinedFlag && !item.copyRequired"
                             class="document__name"
                             :to="{ name: 'document-process', params: { document: item.slug }}">
                    {{item.title}}
                </router-link>

                <!--status uploaded-->
                <router-link v-if="item.status && ! item.isDeclinedFlag && ! documentIdsExpired.includes(item.id)"
                             class="document__name document__name--uploaded document__name--icon"
                             :to="{ name: 'document-confirm-edit', params: { document: item.slug }}">
                    <i class="icon-edit document__icon document__icon--success"></i>
                    {{item.title}} <i class="icon-check"></i>
                </router-link>

                <!--status uploaded & cant edit anymore or declined-->
                <div class="document__name"
                     v-bind:class="{ 'document__name--uploaded': item.status, 'document__name--disabled' : item.isDeclinedFlag }"
                     v-if="documentIdsExpired.includes(item.id) || item.isDeclinedFlag ">
                    {{item.title}} <i class="icon-check" v-if="item.status"></i>
                </div>

                <!--<div class="document__present" v-if="item.status">-->
                    <!--<i class="icon-check icon&#45;&#45;secondary icon&#45;&#45;big"></i>-->
                    <!--<div class="document__present__info">-->
                        <!--<T>Toegevoegd</T>-->
                        <!--<router-link class="document__change" :to="{ name: 'document-upload', params: { document: item.slug }}"-->
                                     <!--v-if="! documentIdsExpired.includes(item.id)">-->
                            <!--<T>Wijzig</T>-->
                        <!--</router-link>-->
                    <!--</div>-->
                <!--</div>-->

                <div class="document__decline" v-if="item.declineFlag">
                    <div v-if="! documentIdsExpired.includes(item.id)">
                        <label class="form__checkbox form__checkbox--no-margin" :for="'decline-' + item.id" v-bind:class="{ 'muted': ! item.isDeclinedFlag }">
                            <input class="form__control form__control--checkbox"
                                   :checked="item.isDeclinedFlag"
                                   :name="'decline-' + item.id"
                                   :id="'decline-' + item.id"
                                   @change="changeDeclineStatus(item, $event)"
                                   type="checkbox">
                            <span class="checkmark checkmark--checkbox"></span>
                            <T>Ik heb dit niet</T>
                        </label>
                    </div>
                </div>

            </li>
        </ul>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        name: 'DocumentList',
        data: function () {
            return {
                documents: null,
                documentIdsExpired: [],
                messages: null,
            }
        },
        computed: mapState(['activeLocale']),
        watch: {
            // when the activeLocale change then try to translate again
            activeLocale() {
                this.getDocuments();
            },
        },
        methods: {
            changeDeclineStatus(document, e) {
                let self = this;
                if(e.target.checked) {
                    this.$router.push({name: 'document-not-available', params: { document: document.slug }})
                } else {
                    this.$Api
                        .post(this.$Api.apiUrl('unset-document-ignore/' + document.slug))
                        .then(function(response){
                            self.getDocuments();
                        });
                }
            },
            getDocuments() {
                let self = this;

                self.$store.commit('setLoading',true);

                self.$Api.get('documents')
                .then(function(response) {
                    self.documents = response.data.documents;
                    self.messages = response.data.messages;

                    _.each(self.documents,function(document,key){
                        if(document.gracePeriodExpiration) {
                            self.checkGracePeriodExpiration(document,key)
                        }
                    });
                });
            },
            setGracePeriodExpired(document) {
                let self = this;

                // if we dont already pus it here the item wil flash
                self.documentIdsExpired.push(document.id);

                // now we do a call to make sure this isen't hacked
                self.$Api.get('grace/' + document.slug)
                    .then(function(response) {
                        if(! response.data.uploadAllowed) {
                            self.documentIdsExpired.push(document.id);
                        } else {
                            var index = self.documentIdsExpired.indexOf(document.id);
                            if (index > -1) {
                                self.documentIdsExpired.splice(index, 1);
                            }
                        }
                    });
            },
            checkGracePeriodExpiration(document) {
                let expirationDate = new Date(document.gracePeriodExpiration);
                let now = new Date();
                let wait = ms => new Promise(resolve => setTimeout(resolve, ms));

                if(now.getTime() > expirationDate.getTime()) {
                    this.setGracePeriodExpired(document);
                    return true;
                }

                // if the date isen't matched return a promise
                return wait(1000).then(() => this.checkGracePeriodExpiration(document));
            },
        },
        created: function() {
            this.getDocuments();
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/components/DocumentList.vue